import React from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { Link, useLocation } from 'react-router-dom';

const contentLinks = [
  { path: '/facturacion/normas', label: 'Normas de Facturación' },
  { path: '/facturacion/modulos-obras-sociales', label: 'Módulos Obras Sociales' },
  { path: '/facturacion/modulos-ioma', label: 'Módulos IOMA' },
  { path: '/facturacion/modulos-especialidad', label: 'Módulos Especialidad' },
  { path: '/facturacion/modulos-otras-practicas', label: 'Otras Prácticas Kinésicas' },
  { path: '/facturacion/reglamento-obras-sociales', label: 'Reglamento Interno OOSS' },
];

export default function ContentNav() {
  const location = useLocation();

  return (
    <Nav pills>
      {contentLinks.map(link => {
        const isActive = location.pathname === link.path;
        return (
          <NavItem key={link.path}>
            <NavLink
              tag={Link}
              to={link.path}
              active={isActive}
              style={isActive ? {
                backgroundColor: '#9123C0',
                color: '#fff',
              } : {
                color: '#9123C0',
              }}
            >
              {link.label}
            </NavLink>
          </NavItem>
        );
      })}
    </Nav>
  );
}
